import { useEffect } from 'react';

// Inputs type=number escrolam silenciosamente quando o usuario rola a pagina
// com o cursor sobre eles, alterando o valor sem perceber. Hook global remove
// o foco do input em scroll, evitando o efeito.
// Montar uma vez no shell raiz (App).
export function useNoScrollNumberInput(): void {
  useEffect(() => {
    function handler() {
      const el = document.activeElement;
      if (el instanceof HTMLInputElement && el.type === 'number') {
        el.blur();
      }
    }
    document.addEventListener('wheel', handler, { passive: true });
    return () => document.removeEventListener('wheel', handler);
  }, []);
}
